import React, { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  actions?: ReactNode;
  children?: ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, actions, children }) => (
  <div className={`bg-gray-50 pb-3 -mx-4 px-4 sm:-mx-6 sm:px-6 lg:-mx-32 lg:px-32 pt-2 border-b border-gray-200 ${children ? 'space-y-3' : ''}`}>
    <div className="flex items-center justify-between gap-3">
      <h1 className="text-xl sm:text-2xl font-bold text-gray-900 truncate">{title}</h1>
      {actions && <div className="flex-shrink-0 hidden sm:flex items-center gap-2">{actions}</div>}
    </div>
    {actions && <div className="sm:hidden space-y-2">{actions}</div>}
    {children}
  </div>
);

export default PageHeader;
